import { traverseSchema} from './traverseSchema'

export const createSchemaTree = (stage, lastLayerIndex = 0) => {
  const schemaTree = {}
  schemaTree.layerIndex = lastLayerIndex
  schemaTree.type = stage.getType()
  schemaTree.children = []

  traverseSchema(stage, schemaTree)

  return schemaTree
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/createSchemaTree.js